//import ProductSpecifications from '@jetshop/ui/ProductSpecifications/ProductSpecifications';
import React, { Component } from 'react';
import styled from 'react-emotion';
import t from '@jetshop/intl';

import MaxWidth from '../Layout/MaxWidth';

// const Description = styled('article')`
//   line-height: 25px;
// `;

export const SectionHeading = styled('h2')`
  font-weight: 600;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  ${({ theme }) => theme.below.md} {
    font-size: 1.125rem;
    font-weight: bold;
    text-transform: uppercase;
  }
`;

export const ProductSection = styled('section')`
  //margin-right: ${({ theme }) => theme.space[2]};
  //margin-left: ${({ theme }) => theme.space[2]};
  width: 100%;
  padding-bottom: 3rem;

  ${props =>
    props.hideArrow &&
    `svg {
      display: none;
    }
    `}

  ${({ theme }) => theme.below.md} {
    //margin: 0;
  }

  ${({ theme }) => theme.above.md} {
    width: ${({ theme }) =>
      `calc(50% - ${theme.space[2]} - ${theme.space[2]})`};
  }
`;

export const ProductSectionImage = styled(ProductSection)`
  ${({ theme }) => theme.above.md} {
    width: ${({ theme }) =>
      `calc(58% - ${theme.space[2]} - ${theme.space[2]})`};
  }
`;

export const ProductSectionInfo = styled(ProductSection)`
  ${({ theme }) => theme.above.md} {
    padding-left: 80px !important;
    width: ${({ theme }) =>
      `calc(42% - ${theme.space[2]} - ${theme.space[2]})`};
  }
`;

const TabMaxwidth = styled(MaxWidth)`
  max-width: 1136px;
  padding: 0 !important;
`;

const TabButton = styled('button')`
  background: none;
  outline: none;
  margin-right: ${({ theme }) => theme.space[5]};
  color: ${({ theme }) => theme.colors.themeGreyMedium};
  line-height: 1.375rem;
  font-size: 1.125rem;
  font-weight: bold;
  text-transform: uppercase;
  transition: color ease-in-out 0.2s;

  &.active,
  &:hover {
    color: ${({ theme }) => theme.colors.themeBlack};
  }

  &:last-of-type {
    margin-right: 0;
  }
`;

const TabHeader = styled('div')`
  padding-bottom: ${({ theme }) => theme.space[2]};
`;

const SingleContent = styled('p')`
  display: none;
  > a {
    display: block;
  }
  &.active {
    display: block;
  }
`;

const TabContainer = styled('div')`
  background: ${({ theme }) => theme.colors.themeGrey};
  ${({ theme }) => theme.elements.fwContainer};
  padding-top: ${({ theme }) => theme.space[5]};
  padding-bottom: ${({ theme }) => theme.space[6]};
  margin-bottom: ${({ theme }) => theme.space[5]};
`;

const BreakFlex = styled('div')`
  max-width: 100%;
`;

//const ProductInfo = ({ product }) => {
class ProductInfo extends Component {
  render() {
    const product = this.props.product;
    let tabTitles = [];
    let tabContent = [];

    const tabs = product.customFields.filter(tab =>
      tab.key.includes('tab-') ? tab : null
    );

    if (tabs) {
      tabs.forEach((tab, i) => {
        tabTitles[i] = tab.title;
        tabContent[i] = tab.stringValue ? tab.stringValue : tab.htmlValue;
      });
    }

    return (
      <BreakFlex>
        <TabContainer>
          <TabMaxwidth>
            <TabHeader>
              <TabButton
                className={
                  parseInt(this.props.activeTab) === 0
                    ? 'active firstButton'
                    : 'firstButton'
                }
                value={0}
                onClick={this.props.selectTab}
              >
                {t('Product description')}
              </TabButton>
              {tabTitles &&
                tabTitles.map((tabTitle, i) => {
                  const ti = i + 1;
                  return (
                    <TabButton
                      className={
                        parseInt(this.props.activeTab) === ti ? 'active' : null
                      }
                      key={i}
                      value={ti}
                      onClick={this.props.selectTab}
                    >
                      {tabTitle}
                    </TabButton>
                  );
                })}
            </TabHeader>
            <SingleContent
              className={parseInt(this.props.activeTab) === 0 ? 'active' : null}
              dangerouslySetInnerHTML={{ __html: product.description }}
            />

            {tabContent &&
              tabContent.map((tabContent, i) => {
                const ti = i + 1;
                return (
                  <SingleContent
                    key={i}
                    className={
                      parseInt(this.props.activeTab) === ti ? 'active' : null
                    }
                    dangerouslySetInnerHTML={{ __html: tabContent }}
                  />
                );
              })}
          </TabMaxwidth>
        </TabContainer>
        {/*
      <ProductSection>
        <SectionHeading>{t('Product description')}</SectionHeading>
        <Description
          dangerouslySetInnerHTML={{
            __html: product.description
          }}
        />
      </ProductSection>
      <ProductSection>
        <SectionHeading>{t('Specifications')}</SectionHeading>
        <ProductSpecifications fields={product.customFields} />
      </ProductSection>
      */}
      </BreakFlex>
    );
  }
}

export default ProductInfo;
